export const splitSizes = item => {
  if (!item.stockPorParte) return [];
  const size = String(item.talleProd || '');
  if (size.startsWith('top:')) return [size.slice(4),''];
  if (size.startsWith('bottom:')) return ['',size.slice(7)];
  return size.split('/');
};
export const sizeLabel = item => {
  const sizes = splitSizes(item);
  if (sizes.length === 2) return [sizes[0] && `Top ${sizes[0]}`,sizes[1] && `Bottom ${sizes[1]}`].filter(Boolean).join(' · ');
  return item.talleTop && item.talleBottom ? `Top ${item.talleTop} · Bottom ${item.talleBottom}` : item.talleProd;
};
export const piecePrice = (product, part) => {
  const label = part === 'top' ? 'Top' : 'Bottom';
  if (product[`precio${label}Prod`] != null) return Number(product[`precio${label}Prod`]);
  const cents = Math.round(Number(product.precioOriginalProd ?? product.precioProd)*100);
  const half = part === 'top' ? Math.ceil(cents/2) : Math.floor(cents/2);
  return Math.floor((half*(100-Number(product.descuentoPorcentaje || 0))+50)/100)/100;
};
export const sameVariant = (a, b) => a.id === b.id && a.colorProd === b.colorProd && a.talleProd === b.talleProd;
export function availableStock(product, items = []) {
  const color = product.colores?.find(color => color.color === product.colorProd);
  if (product.stockPorParte) {
    const sizes = splitSizes(product);
    if (sizes.length !== 2 || !sizes.some(Boolean) || (!/^(top|bottom):/.test(product.talleProd) && sizes.some(size => !size))) return 0;
    return Math.max(0, Math.min(...['top','bottom'].map((part,index) => {
      if (!sizes[index]) return Infinity;
      const stock = Number(color?.[part]?.find(size => size.talle === sizes[index])?.stock) || 0;
      const used = items.filter(item => item.id === product.id && item.colorProd === product.colorProd && item.stockPorParte && !sameVariant(item,product) && splitSizes(item)[index] === sizes[index])
        .reduce((total,item) => total + item.cantidad,0);
      return stock - used;
    })));
  }
  return Math.max(0, Number(color?.talles?.find(talle => talle.talle === product.talleProd)?.stock) || 0);
}
export function addProduct(items, product) {
  const quantity = Math.max(1, Math.floor(Number(product.cantidad) || 1));
  const existing = items.find(item => sameVariant(item, product));
  const cantidad = Math.min((existing?.cantidad || 0) + quantity, availableStock(product,items));
  if (cantidad === 0) return items;
  return existing ? items.map(item => sameVariant(item, product) ? { ...item, cantidad } : item) : [...items, { ...product, cantidad }];
}
export function changeQuantity(items, variant, delta) {
  return items.map(item => sameVariant(item, variant) ? { ...item, cantidad: Math.min(availableStock(item,items), Math.max(0,item.cantidad + delta)) } : item).filter(item => item.cantidad > 0);
}
export function cartTotals(items) {
  return items.reduce((totals,item) => ({totalItems:totals.totalItems+item.cantidad,precioTotal:Math.round((totals.precioTotal+Number(item.precioProd)*item.cantidad)*100)/100}),{totalItems:0,precioTotal:0});
}
